import { useCallback, useRef } from 'react';
import { useSnackbar } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { FavoriteDeliveryType } from 'types/checkout-info';
import { getDeliverySnackText } from '../get-delivery-snack-text';

const FAVORITE_ADDRESS_DELIVERY_SNACK_ID = 'favorite-address-delivery-snack';
const FAVORITE_ADDRESS_DELIVERY_SNACK_AUTO_HIDE_MS = 15000;

export const useFavoriteAddressDeliverySnack = () => {
  const { t } = useTranslation();
  const { addSnack: useAddSnack, removeSnack: useRemoveSnack } = useSnackbar();
  const { current: addSnack } = useRef(useAddSnack);
  const { current: removeSnack } = useRef(useRemoveSnack);

  return useCallback(
    (deliveryType: FavoriteDeliveryType) => {
      const snackText = getDeliverySnackText(deliveryType, t);

      if (!snackText) return;

      removeSnack(FAVORITE_ADDRESS_DELIVERY_SNACK_ID);
      addSnack({
        id: FAVORITE_ADDRESS_DELIVERY_SNACK_ID,
        title: snackText.title,
        content: snackText.description,
        variant: 'success',
        showCloseButton: true,
        testId: 'favorite-address-delivery-notification',
        autoHideTimer: FAVORITE_ADDRESS_DELIVERY_SNACK_AUTO_HIDE_MS,
      });
    },
    [t, addSnack, removeSnack],
  );
};
